import actions from './slide-attributes.actions'
import { mutations } from './slide-attributes.mutations'

const _state = {}

const getters = {
  getCloudImportSource: (state) => (presentationId, slideId) => {
    return state[presentationId]?.[slideId]?.cloudImportSource || null
  },
  // AHA-47691: a content-v2 slide's `dsl` document, once hydrated (SideLeft's
  // plugin-preview hydration or an import replay) — null until then.
  getDsl: (state) => (presentationId, slideId) => {
    const dsl = state[presentationId]?.[slideId]?.dsl
    return typeof dsl === 'string' && dsl ? dsl : null
  },
}

export default {
  namespaced: true,
  actions,
  state: _state,
  mutations,
  getters,
}
